/* =====================================================
   DAR_CUSTOM: DarBeauty Custom JavaScript
   هذا الملف يحتوي جميع السكربتات المخصصة لـ DarBeauty
   عند تحديث الثيم: انسخ هذا الملف كاملاً بدون تعديل
   ===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  /* ===== تنظيف روابط المنتجات من معلمات البحث ===== */
  if (window.location.pathname.includes('/products/')) {
    // التحقق مما إذا كان الرابط الحالي يحتوي على معلمات بحث
    if (window.location.search) {
      // إنشاء URLSearchParams للتعامل مع معلمات البحث
      var urlParams = new URLSearchParams(window.location.search);

      // التحقق من وجود ref=review
      var hasRefReview = urlParams.get('ref') === 'review';

      var cleanUrl;
      if (hasRefReview) {
        // الاحتفاظ فقط بـ ref=review
        cleanUrl = window.location.origin + window.location.pathname + '?ref=review';
      } else {
        // إنشاء الرابط النظيف (بدون معلمات البحث)
        cleanUrl = window.location.origin + window.location.pathname;
      }

      // استخدام history.replaceState لتغيير URL دون إعادة تحميل الصفحة
      history.replaceState({}, document.title, cleanUrl);
    }
  }

  /* ===== فتح الكيبورد عند الضغط على زر البحث ===== */
  var searchLink = document.querySelector('a[href="/search"]');
  var searchInput = document.querySelector('header-search .header-search__input');
  var searchDialog = document.querySelector('header-search[role="dialog"]');
  if (searchLink && searchInput && searchDialog) {
    searchLink.addEventListener('touchend', function (event) {
      event.preventDefault();
      if (!searchDialog.hasAttribute('open')) {
        searchDialog.setAttribute('open', '');
        searchDialog.style.display = 'block';
        // تجنب استدعاء offsetHeight للحد من إعادة التدفق
        setTimeout(function () {
          searchInput.focus();
        }, 10);
      } else {
        searchInput.focus();
      }
    });
  }

  /* ===== إخفاء زر "نفذ من المخزون" عندما يكون المنتج غير متوفر ===== */
  var soldOutButton = document.querySelector('.shopify-product-form .button[disabled]');
  if (soldOutButton) {
    soldOutButton.style.display = 'none';
  }

  /* ===== Footer responsive (updateFooterBlocks on resize/load) ===== */
  var _ftResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_ftResizeTimer);
    _ftResizeTimer = setTimeout(function () { updateFooterBlocks(); }, 100);
  });
  setTimeout(function () { updateFooterBlocks(); }, 0);

  /* ===== تأثيرات لمس الجوال - زر الإضافة السريعة (+) ===== */
  if (!window.matchMedia('(pointer: fine)').matches) {
    var _loadingFailsafeTimer = null;

    // مراقبة نقرات زر + في بطاقات المنتجات
    document.addEventListener('click', function (e) {
      var quickAddBtn = e.target.closest('.product-card__quick-add-button');
      if (!quickAddBtn) return;

      // إذا كان الزر submit داخل form (منتج بخيار واحد) أضف حالة التحميل
      if (quickAddBtn.type === 'submit') {
        quickAddBtn.classList.add('is-loading');

        // DAR_CUSTOM: شبكة أمان — إذا فشل الطلب ولم يصل theme:loading:end، أزل الاسبنر بعد 5 ثوانٍ
        clearTimeout(_loadingFailsafeTimer);
        _loadingFailsafeTimer = setTimeout(function () {
          document.querySelectorAll('.product-card__quick-add-button.is-loading').forEach(function (btn) {
            btn.classList.remove('is-loading');
          });
        }, 5000);
      }
    }, true);

    // إزالة حالة التحميل عند انتهاء طلب السلة
    document.addEventListener('theme:loading:end', function () {
      clearTimeout(_loadingFailsafeTimer);
      document.querySelectorAll('.product-card__quick-add-button.is-loading').forEach(function (btn) {
        btn.classList.remove('is-loading');
      });
    });
  }
  /* ===== قوائم الفوتر القابلة للطي لأجهزة الجوال ===== */
  var footerBlocksProcessed = false;

  function updateFooterBlocks() {
    var isMobile = window.innerWidth <= 699;
    var footerBlocks = document.querySelectorAll('.footer__block');

    // تنفيذ التحويل فقط إذا كان الوضع مختلفًا عن الحالة السابقة
    if (isMobile && !footerBlocksProcessed) {
      footerBlocks.forEach(function (block) {
        var title = block.querySelector('.h6');
        if (title) {
          // تخزين المحتوى الأصلي لاستخدامه لاحقًا عند الحاجة
          if (!block.dataset.originalContent) {
            block.dataset.originalContent = block.innerHTML;
          }

          var content = title.nextElementSibling;
          var accordionDisclosure = document.createElement('accordion-disclosure');
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.innerHTML = title.textContent + '<span class="animated-plus"></span>';
          details.appendChild(summary);
          if (content) {
            details.appendChild(content.cloneNode(true));
          }
          accordionDisclosure.appendChild(details);

          // استخدام replaceChildren بدلاً من innerHTML للأداء الأفضل
          while (block.firstChild) {
            block.removeChild(block.firstChild);
          }
          block.appendChild(accordionDisclosure);
        }
      });
      footerBlocksProcessed = true;
    } else if (!isMobile && footerBlocksProcessed) {
      // إعادة المحتوى الأصلي عند العودة إلى وضع سطح المكتب
      footerBlocks.forEach(function (block) {
        if (block.dataset.originalContent) {
          block.innerHTML = block.dataset.originalContent;
        }
      });
      footerBlocksProcessed = false;
    }
  }
  /* ===== مغير اللغة والبلد الموحد ===== */
  (function () {
    var popup = document.getElementById('dar-locale-popup');
    if (!popup) return;

    var langToggle = document.getElementById('dar-lang-toggle');
    var formLocale = document.getElementById('dar-form-locale');
    var formCountry = document.getElementById('dar-form-country');
    var applyBtn = document.getElementById('dar-locale-apply');

    // القيم الأصلية عند فتح الـ popup (تُحدَّث عند كل فتح)
    var initialLang = '';
    var initialCountry = '';

    // تحديث حالة زر التطبيق
    function updateApplyState() {
      if (!applyBtn || !formLocale || !formCountry) return;
      var hasChanged = formLocale.value !== initialLang
                    || formCountry.value !== initialCountry;
      applyBtn.disabled = !hasChanged;
      applyBtn.classList.toggle('is-disabled', !hasChanged);
    }

    // مزامنة اللغة مع الحقل المخفي (أزرار أفقية)
    if (langToggle && formLocale) {
      langToggle.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-lang-toggle__btn');
        if (!btn || btn.classList.contains('is-active')) return;
        langToggle.querySelectorAll('.dar-lang-toggle__btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        formLocale.value = btn.dataset.langCode;
        updateApplyState();
      });
    }

    // معالجة اختيار البلد من القائمة الجديدة (buttons with flags)
    var countryList = document.getElementById('dar-country-list');
    if (countryList && formCountry) {
      countryList.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-country-list__item');
        if (!btn) return;

        var code = btn.dataset.countryCode;
        if (!code) return;

        // تحديث الحقل المخفي
        formCountry.value = code;

        // تحديث التحديد البصري
        countryList.querySelectorAll('.dar-country-list__item').forEach(function (item) {
          item.classList.remove('is-selected');
          var check = item.querySelector('.dar-country-list__check');
          if (check) check.remove();
        });

        btn.classList.add('is-selected');
        var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkSvg.setAttribute('class', 'dar-country-list__check');
        checkSvg.setAttribute('width', '14');
        checkSvg.setAttribute('height', '14');
        checkSvg.setAttribute('viewBox', '0 0 16 16');
        checkSvg.setAttribute('fill', 'none');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M3 8.5L6.5 12L13 4');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        checkSvg.appendChild(path);
        btn.appendChild(checkSvg);

        updateApplyState();
      });
    }

    // فتح الـ popup
    document.querySelectorAll('[data-open-locale-popup]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // حفظ القيم الأصلية عند كل فتح
        initialLang = formLocale ? formLocale.value : '';
        initialCountry = formCountry ? formCountry.value : '';
        updateApplyState();

        // إذا كان الزر داخل السايدبار → أغلق السايدبار أولاً
        var sidebar = trigger.closest('header-sidebar');
        if (sidebar) {
          sidebar.removeAttribute('open');
          setTimeout(function () { popup.showModal(); }, 350);
        } else {
          popup.showModal();
        }
      });
    });

    // إغلاق الـ popup
    popup.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.close();
      });
    });

    // منع إغلاق عند الضغط على المحتوى
    var panel = popup.querySelector('.dar-locale-popup__panel');
    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // حالة التحميل عند الإرسال
    if (applyBtn) {
      var form = applyBtn.closest('form');
      if (form) {
        form.addEventListener('submit', function () {
          applyBtn.disabled = true;
          var textEl = applyBtn.querySelector('.dar-locale-popup__apply-text');
          var loaderEl = applyBtn.querySelector('.dar-locale-popup__apply-loader');
          if (textEl) textEl.style.display = 'none';
          if (loaderEl) loaderEl.hidden = false;
        });
      }
    }
  })();
});